import { defineStore } from "pinia";

// Only cached in memory; older versions kept a localStorage copy, removed on fetch.
const LEGACY_CACHE_KEY = 'store_availabilities';

export const useCatalogPublicationAvailabilitiesStore = defineStore("CatalogPublicationAvailabilitiesStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchCatalogPublicationAvailabilities() {
      if (this.data) return;

      localStorage.removeItem(LEGACY_CACHE_KEY);
      this.loading = true;
      try {
        const response = await this.$axios.get('/api/v1/catalog/availabilities.json');
        this.data = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    }
  }
});
